import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IGetVendorAccountsData {
  id: number;
  code_type: string;
  area_id: string;
  pool_id: string;
  department: string;
  vendor_code: string;
  vendor_name: string;
  bank_account: string;
  bank_account_name: string;
  bank_account_number: string;
  is_active: boolean;
  create_by: string;
  create_at: string;
  update_by: string;
  update_at: string;
  company_code: string;
  is_withdrawal: boolean;
}
export interface IGetVendorAccountsResponse {
  lstsmplmstvendorset: IGetVendorAccountsData[];
}

export const url = "/v1/smplmstvendorset";

export const getVendorAccounts = async (
  codeType: string,
  areaId: string,
  poolId: string,
  department: string,
  companyCode?: string,
): Promise<IGetVendorAccountsResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/codetype/${codeType}/areaid/${areaId}/poolid/${poolId}/department/${department}`,
    method: "GET",
    params: {
      company_code: companyCode,
    },
  });

  return data;
};
